<template>
  <section :class="$style.header">
    <header>
      <router-link :class="$style.logo" to="/">
        <img
          alt="legend logo"
          src="@/assets/img/menu/header-logo-black-wrap.svg"
        />
      </router-link>
      <nav>
        <ul>
          <li>
            <router-link to="/partner/faq">
              {{ $t("FAQ") }}
            </router-link>
          </li>
          <li>
            <a
              href="https://otc.legendtrading.com/partners/login"
              target="_blank"
            >
              {{ $t("Sign In") }}
            </a>
          </li>
          <li :class="$style.lang" :data-locale="$i18n.locale">
            <a
              href="#"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              @click.prevent="isDropdownVisible = !isDropdownVisible"
            >
              <component :is="iconFlag" :class="$style.flag" />
              <a-icon
                :class="{ [$style.expand]: isDropdownVisible }"
                type="caret-down"
                theme="filled"
              />
            </a>

            <div v-show="isDropdownVisible" aria-labelledby="navbarDropdown">
              <a href="javascript: void 0" @click.prevent="updateLang('en')">
                <svg-flag-us :class="$style.flag" />
                English
              </a>
              <a href="javascript: void 0" @click.prevent="updateLang('zh')">
                <svg-flag-cn :class="$style.flag" />
                简体中文
              </a>
            </div>
          </li>
        </ul>
      </nav>
    </header>
  </section>
</template>

<script>
import Vue from "vue";
import { Icon } from "ant-design-vue";
import svgFlagUs from "flag-icons/flags/1x1/us.svg?inline";
import svgFlagCn from "flag-icons/flags/1x1/cn.svg?inline";
import svgFlagXx from "flag-icons/flags/1x1/xx.svg?inline";

export default Vue.extend({
  name: "PartnerHeader",
  data() {
    return {
      isDropdownVisible: false
    };
  },
  components: {
    [Icon.name]: Icon,
    svgFlagUs,
    svgFlagCn,
    svgFlagXx
  },
  computed: {
    iconFlag() {
      switch (this.$i18n.locale) {
        case "en":
          return svgFlagUs;
        case "zh":
          return svgFlagCn;
        default:
          return svgFlagXx;
      }
    }
  },
  methods: {
    updateLang(lang) {
      this.isDropdownVisible = false;
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang;
      }
    }
  }
});
</script>

<style module lang="scss">
.header {
  background: colors(light);
  position: relative;
  z-index: 10;

  & > header {
    @include rfs(0.875rem);
    @include padding(1.3rem);
    @include rfs(90rem, max-width);
    align-items: center;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin: 0 auto;
    & > nav > ul {
      display: flex;
      justify-content: space-between;
      &,
      & > li {
        margin: 0;
        padding: 0;
      }
      & > li {
        list-style: none;
        &:not(:last-child) {
          @include margin-right(1rem);
        }
      }
    }
    & li a {
      @include padding(0.5rem 1rem);
      @include rfs(1.25rem, line-height);
      border-radius: 0.5rem;
      color: colors(dark);
      display: block;
      &:hover {
        background-color: colors(light-gray);
        color: colors(dark-gray);
      }
      &:active {
        background-color: colors(light-gray);
        color: colors(theme);
      }
      &:global(.router-link-exact-active) {
        font-weight: 600;
        color: colors(dark-gray);
      }
    }
  }

  .logo > img {
    @include rfs(3rem, height);
    @include rfs(8rem, width);
    @include margin(0 1rem 0 0);
  }
  .lang {
    position: relative;
    & :global(.anticon) {
      transition: 0.2s ease-in-out;
      &.expand {
        transform: rotate(180deg);
      }
    }
    & a {
      align-items: center;
      display: flex;
      flex-flow: row nowrap;
      & > .flag {
        @include rfs(1.25rem, height);
        @include rfs(1.25rem, width);
        @include margin-right(0.5rem);
      }
    }
    & > div {
      @include padding(0.5rem 0);
      @include rfs(0.25rem, border-radius);
      background: colors(light);
      border: 1px solid colors(gray);
      position: absolute;
      right: 0;
      top: 100%;
      white-space: nowrap;
      & > a {
        &:hover {
          background: colors(light-gray);
        }
      }
    }
  }
  .flag {
    @include rfs(1rem, height);
    @include rfs(1rem, width);
    border-radius: 50%;
  }
}
</style>
